export const STATUS_MESSAGE_RULES = Object.freeze({
    /*
     * --- Aus der Kolonne ----------------------------------------------------
     *
     * Alles hier richtet sich **an** die Führung — deshalb setzt sie es nicht
     * selbst ab. Diese Meldungen sind `follower`, ohne Ausnahme außer der
     * Panne.
     *
     * Warum das mehr ist als eine Feinheit: Der Empfängerkreis `leadership`
     * besteht aus Führung, Schlusswagen und dem Absender. Schickt die Führung
     * eine solche Meldung und es gibt gerade keinen Schlusswagen, ist sie
     * selbst der ganze Empfängerkreis — und die eigene Meldung springt einen
     * nicht an. Die Meldung ginge ins Leere, und der Fahrer wüsste es nicht.
     * Genau so auf der Fahrt am 14.08.2026 aufgefallen.
     */
    /** Antwort auf die Nachfrage der Führung — die Führung hat gefragt, sie bekommt sie. */
    ok: { sender: 'follower', audience: 'leadership', acknowledged: false },
    break: { sender: 'follower', audience: 'leadership', acknowledged: false },
    fuel: { sender: 'follower', audience: 'leadership', acknowledged: false },
    /**
     * Die einzige Meldung aus der Kolonne, die alle angeht — und die einzige,
     * die auch die Führung absetzt: Eine Panne trifft sie genauso, und dann
     * muss es die ganze Kolonne wissen. Der Hintermann darf nicht warten, und
     * die Kolonne muss halten.
     */
    breakdown: { sender: 'anyone', audience: 'all', acknowledged: false },
    /** Wer führt, kann den Anschluss an sich selbst nicht verlieren. */
    lost: { sender: 'follower', audience: 'leadership', acknowledged: false },
    slow_down: { sender: 'follower', audience: 'leadership', acknowledged: false },
    // --- Von der Führung an die Kolonne -------------------------------------
    stop: { sender: 'leader', audience: 'all', acknowledged: true },
    break_soon: { sender: 'leader', audience: 'all', acknowledged: true },
    close_up: { sender: 'leader', audience: 'all', acknowledged: true },
    hazard: { sender: 'leader', audience: 'all', acknowledged: true },
    check_in: { sender: 'leader', audience: 'all', acknowledged: true },
});
/** Darf diese Rolle diese Art von Meldung absetzen? */
export function maySendStatusMessage(kind, role) {
    switch (STATUS_MESSAGE_RULES[kind].sender) {
        case 'anyone':
            return true;
        case 'leader':
            return role === 'leader';
        case 'follower':
            return role !== 'leader';
    }
}
/**
 * Bekommt dieser Teilnehmer die Meldung zu sehen?
 *
 * Der Absender ist immer dabei — sonst stünde die eigene Meldung nicht im
 * eigenen Verlauf, und man wüsste nicht, ob sie überhaupt abgegangen ist.
 */
export function receivesStatusMessage(kind, role, isSender) {
    if (isSender) {
        return true;
    }
    return (STATUS_MESSAGE_RULES[kind].audience === 'all' || role === 'leader' || role === 'sweeper');
}
/**
 * War dieser Teilnehmer schon dabei, als die Meldung abgesetzt wurde?
 *
 * Eine Meldung geht die an, die sie hätte erreichen können — sonst niemanden.
 * Wer heute beitritt, hat mit dem „Wir halten an" von gestern nichts zu tun:
 * Es sprang ihm beim ersten Öffnen als Balken entgegen, stand in seinem
 * Verlauf, und bei der Führung wartete eine Lesebestätigung von jemandem, der
 * zu dieser Zeit gar nicht in der Kolonne war.
 *
 * Beobachtet am 17.08.2026, als zum ersten Mal jemand während einer laufenden
 * Ausfahrt hinzukam.
 *
 * Diese Regel gilt an drei Stellen — beim Verschicken des Verlaufs, beim
 * Balken auf dem Gerät und bei der Lesebestätigung — und steht deshalb hier
 * und nicht dreimal im Code.
 */
export function presentWhenSent(joinedAt, messageCreatedAt) {
    return messageCreatedAt >= joinedAt;
}
/** Wird der Empfang dieser Art von Meldung zurückgemeldet? */
export function isAcknowledged(kind) {
    return STATUS_MESSAGE_RULES[kind].acknowledged;
}
//# sourceMappingURL=statusMessages.js.map